__turbopack_context__.v({
  "actions": "styles-module-scss-module__2qaY1G__actions",
  "cropArea": "styles-module-scss-module__2qaY1G__cropArea",
  "cropImg": "styles-module-scss-module__2qaY1G__cropImg",
  "cropWrapper": "styles-module-scss-module__2qaY1G__cropWrapper",
  "inlinePanel": "styles-module-scss-module__2qaY1G__inlinePanel",
});
